import {createSelector} from 'reselect';
import {appConfig} from '@stencil/hotels-config';
export const reviewStaticDataHNSelector = state =>
  state.review?.descblockResponse?.cdata?.HotelName;
export const reviewStaticDataAddressSelector = state =>
  state.review?.descblockResponse?.cdata?.HotelAddress;
export const reviewStaticDataImageSelector = state => state.review?.descblockResponse?.cdata?.Image;
export const reviewStaticDataCheckinDisplayDate = state =>
  state.review?.descblockResponse?.cdata?.checkin_display || '';
export const reviewStaticDataCheckoutDisplayDate = state =>
  state.review?.descblockResponse?.cdata?.checkout_display || '';

export const reviewStaticInclusionsSelector = state =>
  state.review?.descblockResponse?.cdata?.Inclusions || [];

export const revieStaticDataCheckinTime = state =>
  state.review?.descblockResponse?.cdata?.checkintime;
export const revieStaticDataCheckoutTime = state =>
  state.review?.descblockResponse?.cdata?.checkouttime;
const descBlockCdata = state => state.review?.descblockResponse?.cdata || {};
export const hasDescblockDataSelector = createSelector(
  descBlockCdata,
  item => !!Object.keys(item).length,
);

export const reviewPagePricing = state => state.review?.descblockResponse?.cdata?.fb_list || [];
export const fareBreakUpSelector = createSelector(reviewPagePricing, item => item);
const reviewSelector = state => state.review || {};
const appliedPromocode = state => state.review?.descblockInput?.code || '';
export const appliedPromocodeSelector = createSelector(appliedPromocode, item => item);
const promoMessage = state => state.review?.descblockResponse?.promo_message;
const promoShortMessage = state => state.review?.descblockResponse?.short_message;
const ifPromoApplied = state => state.review?.descblockResponse?.cdata?.promo_applied;
const promoList = state => state.review?.descblockResponse?.cdata?.applicablepromolist;
const noOfAdults = state => state.review?.descblockResponse?.cdata?.noofAdults || 0;
export const noOfAdultsSelector = createSelector(noOfAdults, item => item);
const noofChildren = state => state.review?.descblockResponse?.cdata?.noofChildren || 0;

export const noOfChildrenSelector = createSelector(noofChildren, item => item);
const grandTotal = state => state.review?.descblockResponse?.cdata?.grandtotal;
const finalAmount = state =>
  state.review?.descblockResponse?.cdata?.personalized_keys?.np_wogc ||
  state.review?.descblockResponse?.cdata?.aftrpromototaldisplay;

export const finalAmountSelector = createSelector(finalAmount, item => parseInt(item, 10) || 0);

const finalAmountAfterGocash = state =>
  state.review?.descblockResponse?.cdata?.personalized_keys?.np_wt;

export const finalAmountAfterGocashSelector = createSelector(
  finalAmountAfterGocash,
  item => parseInt(item, 10) || 0,
);

export const amountWithoutDiscountSelector = createSelector(
  descBlockCdata,
  item => item?.personalized_keys?.tp_alltax || 0,
);

const roomType = state => state.review?.descblockResponse?.cdata?.RoomTypeName || '';
export const roomTypeSelector = createSelector(roomType, item => item);
export const propertyTypeSelector = createSelector(
  descBlockCdata,
  item => item?.property_type || '',
);
const numberOfRooms = state => state.review?.descblockResponse?.cdata?.noofRooms || 0;
export const numberOfRoomsSelector = createSelector(numberOfRooms, item => item);

const numberOfNights = state => state.review?.descblockResponse?.cdata?.noofNights || 0;
export const numberOfNightsSelector = createSelector(numberOfNights, item => item);
const freeCancelDate = state => state.review?.descblockResponse?.cdata?.vendor_fcdt_org || '';

export const freeCancellationDateSelector = createSelector(freeCancelDate, item => item);
const hotelStars = state => state.review?.descblockResponse?.cdata?.star || 0;
const descBlockOfferKey = state => state.review?.descblockResponse?.offer_key || 0;
const descBlockSuccess = state => state.review?.descblockResponse?.success;
const descBlockInputVendor = state => state.review?.descblockInput?.v || 'v3';
const descBlockInput = state => state.review?.descblockInput;

const paymentResponseSuccess = state => state.review?.paymentsData?.success || false;
const payMode = state => state.review?.descblockResponse?.cdata?.pay_mode;
const paymentType = state => state.review?.descblockResponse?.cdata?.payment_type;
const hotelsPaymentLoading = state => state.review?.paymentsData?.loading;
const descblockLoading = state => state.review?.descblockResponse?.loading;
const bookingDetails = state => state.review?.paymentsData?.bookdetails;
const paymentModuleOpen = state => state.review?.paymentOpen;
const useGocashStatus = state => state.review?.useGoCash;
const maxGocash = state => state.review?.descblockResponse?.cdata?.max_gocash || 0;
const totalCredits = state => state.review?.descblockResponse?.cdata?.total_credits || 0;

const addOnList = state => state.review?.descblockResponse?.cdata?.addon_list || [];

// const addOnD = [
//   {
//      "add_on":37117,
//      "cancellation_rule":"Refundable As Per Rateplan Cancellation Policy",
//      "charges_type":"flat_rate",
//      "charges_value":599.8,
//      "desc":"EARLY CHECK-IN 06:00 AM Rs.599.8 per Room",
//      "end_time":"",
//      "id":37117,
//      "net_amount":0,
//      "pay_mode":2,
//      "pay_mode_text":"Pay at Hotel",
//      "sell_amount":599.8,
//      "start_time":"06:00 AM",
//      "text":"6 AM Early Checkin",
//      "title":"EARLY CHECK-IN ",
//      "type":"early_cin",
//      "units":1,
//   }
// ];
export const addOnListSelector = createSelector(addOnList, item => item);
const earlycheckin = state => state.review?.earlycheckin;
const extraMessages = state => state.review?.descblockResponse?.cdata?.extramsg || [];

export const extraMessagesSelector = createSelector(extraMessages, item => item);
const panIsMandatory = state =>
  state.review?.descblockResponse?.cdata?.user_pan_config_data?.is_mandatory;
const enablePanCard = state =>
  state.review?.descblockResponse?.cdata?.user_pan_config_data?.enable_pan_card;
const countryCodes = state => state.review?.countryCodes || [];

const internationalCurrency = state =>
  state.review?.descblockResponse?.cdata?.farebreakup?.unconverteddata?.Currency || '';
const internationalTotalAmount = state =>
  state.review?.descblockResponse?.cdata?.farebreakup?.unconverteddata?.totalRoomRent || 0;
const reviewEMIDetails = state => state.review?.descblockResponse?.cdata?.emi_details;

const hotelsPolicyApiDataFn = state => state.review?.policies?.hotelPolicy || [];

const gdsPolicyFn = createSelector(descBlockCdata, item => item?.gds_policy || {});

export const hotelsPolicySelector = createSelector(
  hotelsPolicyApiDataFn,
  gdsPolicyFn,
  (hotelsPolicyApiData: Array<string>, gdsPolicyData) => gdsPolicyData?.hp || hotelsPolicyApiData,
);

const cancellationPolicyApiDataFn = state => state.review?.policies?.cancelPolicy || [];

export const cancellationPolicySelector = createSelector(
  cancellationPolicyApiDataFn,
  gdsPolicyFn,
  (cancellationPolicyApiData, gdsPolicyData) => gdsPolicyData?.cp || cancellationPolicyApiData,
);

const additionalHotelsPolicy = state => state.review?.policies?.additional_hotel_policy || {};
export const thingsYoushouldKnow = createSelector(
  additionalHotelsPolicy,
  additionalHotelsPolicy => additionalHotelsPolicy['Hotel Policy'] || [],
);
const policiesLoading = state => state.review?.policies?.loading;

const checkinTimeList = state => state.review?.descblockResponse?.cdata?.checkin_time_array || [];

export const countryCodesSelector = createSelector(countryCodes, item => item);
export const descblockInputSelector = createSelector(descBlockInput, item => item);

export const checkinTimeListSelector = createSelector(checkinTimeList, item => item);
export const hotelAreaReviewInput = createSelector(
  descblockInputSelector,
  item => item.hotelArea || '',
);
export const cityCodeReviewInput = createSelector(
  descblockInputSelector,
  item => item.cityCode || '',
);

export const openOfferSuccessModalSelector = createSelector(
  descblockInputSelector,
  item => item.openOfferSuccessModal,
);
export const tncAgreementSelector = createSelector(reviewSelector, item => item?.agreeTnC);
export const policyErrorSelector = createSelector(
  reviewSelector,
  item => item?.policies?.error || false,
);

export const openPoliciesModalSelector = createSelector(
  reviewSelector,
  item => item.openPolicies || false,
);
export const roomDetailsSelector = createSelector(
  roomType,
  numberOfRooms,
  freeCancelDate,
  hotelStars,
  addOnList,
  extraMessages,
  hotelsPolicySelector,
  cancellationPolicySelector,
  thingsYoushouldKnow,
  tncAgreementSelector,
  policyErrorSelector,
  openPoliciesModalSelector,
  (
    roomType,
    numberOfRooms,
    freeCancellationDate,
    hotelStars,
    addOnList,
    extraMessages,
    hotelsPolicy,
    cancellationPolicy,
    thingsYoushouldKnow,
    tncAgreement,
    policyError,
    isPolicyModalOpen,
  ) => ({
    roomType,
    numberOfRooms,
    freeCancellationDate,
    addOnList,
    hotelStars,
    extraMessages,
    hotelsPolicy,
    cancellationPolicy,
    thingsYoushouldKnow,
    tncAgreement,
    policyError,
    isPolicyModalOpen,
  }),
);

export const totalPaxSelector = createSelector(
  noOfAdults,
  noofChildren,
  (noOfAdults, noofChildren) => noOfAdults + noofChildren,
);

export const roomPaxDetails = createSelector(
  noOfAdults,
  noofChildren,
  numberOfRooms,
  numberOfNights,
  (noOfAdults, noofChildren, numberOfRooms, numberOfNights) => ({
    totalPax: noOfAdults + noofChildren,
    numberOfRooms,
    numberOfNights,
  }),
);

export const appliedPromoSelector = createSelector(
  appliedPromocode,
  promoMessage,
  promoShortMessage,
  ifPromoApplied,
  (appliedPromocode, promoMessage, promoShortMessage, ifPromoApplied) => ({
    appliedPromocode,
    promoMessage,
    promoShortMessage,
    promoApplied: ifPromoApplied || false,
  }),
);
export const promoListSelector = createSelector(promoList, item => item || []);

export const reviewStaticDataSelector = createSelector(
  reviewStaticDataHNSelector,
  reviewStaticDataAddressSelector,
  reviewStaticDataImageSelector,
  hotelStars,
  (hn, address, hotelImage, hotelStars) => ({
    hn,
    address,
    hotelImage,
    hotelStars,
  }),
);

export const reviewCheckinCheckoutDetailsSelector = createSelector(
  reviewStaticDataCheckinDisplayDate,
  reviewStaticDataCheckoutDisplayDate,
  revieStaticDataCheckinTime,
  revieStaticDataCheckoutTime,
  (checkinDisplayDate, checkoutDisplayDate, checkinDisplayTime, checkoutDisplayTime) => ({
    checkinDisplayDate,
    checkoutDisplayDate,
    checkinDisplayTime,
    checkoutDisplayTime,
  }),
);

export const reviewEMIDetailsSelector = createSelector(reviewEMIDetails, reviewEMIDetails => ({
  e9: reviewEMIDetails?.emi_description?.nine_months || '',
  e6: reviewEMIDetails?.emi_description?.six_months || '',
  e3: reviewEMIDetails?.emi_description?.three_months || '',
  bas: reviewEMIDetails?.emi_description?.base_price || '',
  tax: reviewEMIDetails?.emi_description?.tax_and_fee || '',
  fin: reviewEMIDetails?.emi_description?.final_price || '',
  emi: reviewEMIDetails?.emi || '',
}));

export const reviewPagePricingSelector = createSelector(
  reviewPagePricing,
  grandTotal,
  finalAmountSelector,
  internationalCurrency,
  internationalTotalAmount,
  reviewEMIDetailsSelector,
  finalAmountAfterGocashSelector,
  (
    reviewPagePricing,
    grandTotal,
    finalAmount,
    internationalCurrency,
    internationalTotalAmount,
    emiDetails,
    finalAmountAfterGocash,
  ) => ({
    reviewPagePricing,
    grandTotal,
    finalAmount,
    internationalCurrency,
    internationalTotalAmount,
    emiDetails,
    finalAmountAfterGocash,
  }),
);

export const instantPricingDiscountSelector = createSelector(descBlockCdata, cdata => {
  const {farebreakup = {}} = cdata;
  if (farebreakup && typeof farebreakup === 'object') {
    const {promoDiscount_pg_type = '', promoDiscount_pg_display = 0} = farebreakup || {};
    const showInstantPrice =
      parseInt(promoDiscount_pg_display, 10) && promoDiscount_pg_type === 'instant'
        ? parseInt(promoDiscount_pg_display, 10)
        : 0;
    return showInstantPrice;
  }
  return 0;
}); // instant price discount is for additional offers, like bank offers.

export const activePayModeSelector = createSelector(payMode, item => item);
export const paymentsDataSelector = createSelector(
  descBlockSuccess,
  paymentResponseSuccess,
  payMode,
  paymentType,
  hotelsPaymentLoading,
  bookingDetails,
  descBlockCdata,
  descBlockOfferKey,
  descBlockInputVendor,
  (
    descBlockSuccess,
    paymentResponseSuccess,
    payMode,
    paymentType,
    hotelsPaymentLoading,
    bookingDetails,
    descBlockCdata,
    descBlockOfferKey,
    descBlockInputVendor,
  ) => ({
    descBlockSuccess,
    paymentResponseSuccess,
    payMode,
    paymentType,
    hotelsPaymentLoading,
    bookingDetails,
    descBlockCdata,
    descBlockOfferKey,
    vendor: descBlockInputVendor || 'v3',
  }),
);

export const isPahSelector = createSelector(payMode, paymentType, (payMode, paymentType) => ({
  isPah: (paymentType === 2 && payMode !== 3) || payMode === 5,
  isPahCC: paymentType === 2 && payMode === 3,
}));

export const paymentModuleOpenSelector = createSelector(paymentResponseSuccess, item => item);

export const useGocashStatusSelector = createSelector(useGocashStatus, item => item);

export const maxGocashSelector = createSelector(maxGocash, item => item || 0);

export const descblockLoadingSelector = createSelector(descblockLoading, item => item);

export const hotelsPaymentLoadingSelector = createSelector(hotelsPaymentLoading, item => item);

export const loadersStatusSelector = createSelector(
  descblockLoadingSelector,
  hotelsPaymentLoadingSelector,
  (descblockLoading, hotelsPaymentLoading) => ({descblockLoading, hotelsPaymentLoading}),
);

export const goStayBannerPersuasionDataSelector = createSelector(descBlockCdata, item => {
  const {gostays_mbg_data: goStayBannerData = {}} = item;

  if (typeof goStayBannerData === 'object' && Object.keys(goStayBannerData).length) {
    return {
      heading: goStayBannerData?.gr_t,
      subHeading: goStayBannerData?.gr_st,
    };
  }
  return null;
});

export const earlycheckinSelector = createSelector(earlycheckin, item => item);

export const goCashDetailsSelector = createSelector(
  maxGocash,
  totalCredits,
  (maxGocash, totalCredits) => ({totalCredits, maxGocash}),
);

export const needPanSelector = createSelector(
  panIsMandatory,
  enablePanCard,
  (panIsMandatory, enablePanCard) => (panIsMandatory && enablePanCard && true) || false,
);

export const isGoSafeSelector = createSelector(descBlockCdata, item => item?.is_gosafe || false);

export const viewAllOffersSelector = createSelector(reviewSelector, item => ({
  offersList: item?.offers?.promo_list || [],
  loading: item?.offers?.loading,
}));

export const donateCharitySelector = createSelector(reviewSelector, item => item.donate);

export const charityDetailsFn = (item = {additional_options: []}) => {
  const {additional_options = []} = item;
  let data = null;
  if (additional_options.length) {
    data = additional_options[0];
  }
  return data;
};

export const charityDetailsSelector = createSelector(descBlockCdata, charityDetailsFn);

export const charityAmountToBeAddedSelector = createSelector(
  donateCharitySelector,
  charityDetailsSelector,
  (donateCharity, charityDetails) => {
    if (charityDetails) {
      const {is_pre_check = false, sell_price = 0} = charityDetails;
      let price = 0;
      if (is_pre_check && !donateCharity) {
        price = -sell_price;
      } else if ((is_pre_check && donateCharity) || (!is_pre_check && !donateCharity)) {
        price = 0;
      } else if (!is_pre_check && donateCharity) {
        price = sell_price;
      }
      return price;
    }
    return 0;
  },
);

export const avlPayModesSelector = createSelector(
  descBlockCdata,
  item => item?.avl_pay_modes || [],
);

// const d = [
//   {
//     pay_now_amount: 1,
//     pay_txt:
//       'Pay only \u20b91 and get a confirmed booking. You authorize us to deduct the balance amount of \u20b9%%due_amount%% from the same credit card on Aug 22, 2020',
//     header: 'Book @ \u20b91',
//     amount: 2341,
//     due_amount: 2340,
//     fcdt_txt: 'Free cancellation till Aug 24, 2020 12:00 hours',
//     pm: 8,
//   },
//   {
//     pay_now_amount: 1,
//     pay_txt: '',
//     header: 'Pay entire \u20b9%%amount%% now',
//     amount: 2341,
//     due_amount: 2340,
//     fcdt_txt: 'Free cancellation till Aug 24, 2020 12:00 hours',
//     pm: 1,
//   },
// ];

export const isBnplSelector = createSelector(avlPayModesSelector, item => {
  let isBnpl = false;
  if (item && Array.isArray(item)) {
    item.forEach(({pm = ''}) => {
      if (pm == appConfig.payModes.bnpl) isBnpl = true;
    });
  }
  return isBnpl;
});

const descblockUserInfo = state => state.review?.descblockResponse?.userPrefill?.userInfo || {};
export const descblockUserInfoSelector = createSelector(descblockUserInfo, item => item);

export const guestDetailsSharedSelectors = createSelector(
  isBnplSelector,
  needPanSelector,
  tncAgreementSelector,
  (isBnpl, isPan, tncAgreement) => ({isBnpl, isPan, tncAgreement}),
);
